export { default as Img200 } from './processed/200/The-Night-Manager.jpg';
export { default as Img400 } from './processed/400/The-Night-Manager.jpg';
export { default as Imgthumb } from './processed/thumb/The-Night-Manager.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/The-Night-Manager.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/The-Night-Manager.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      156,
      148,
      68
    ],
    "_population": 1,
    "_hsl": [
      0.15151515151515152,
      0.3928571428571429,
      0.4392156862745098
    ]
  },
  "LightVibrant": {
    "_rgb": [
      223,
      199,
      177
    ],
    "_population": 493,
    "_hsl": [
      0.07971014492753624,
      0.4181818181818182,
      0.7843137254901961
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      110,
      21,
      55
    ],
    "_population": 8,
    "_hsl": [
      0.9363295880149813,
      0.6793893129770993,
      0.25686274509803925
    ]
  },
  "Muted": {
    "_rgb": [
      166,
      135,
      94
    ],
    "_population": 72,
    "_hsl": [
      0.0949074074074074,
      0.288,
      0.5098039215686274
    ]
  },
  "LightMuted": {
    "_rgb": [
      206,
      192,
      181
    ],
    "_population": 684,
    "_hsl": [
      0.07333333333333326,
      0.2032520325203252,
      0.7588235294117647
    ]
  },
  "DarkMuted": {
    "_rgb": [
      39,
      62,
      76
    ],
    "_population": 2802,
    "_hsl": [
      0.5630630630630631,
      0.3217391304347826,
      0.22549019607843138
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/The-Night-Manager.js